import { cn } from "@/lib/utils"
import { HTMLAttributes } from "react"

function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={ cn("animate-pulse rounded-md bg-nfBlue-700/30 [&_*:not(:first-child)]:invisible text-transparent", className, "relative") }
      { ...props }
    >
      <div className="absolute overflow-hidden w-full h-full inset-0 rounded-[inherit]">
        <div className="absolute h-full w-[calc(100%+14rem)] inset-0 slide-in-from-left animate-[enter_1.5s_infinite_ease-in-out] sm:animate-[enter_2s_infinite_ease-in-out] lg:animate-[enter_3s_infinite_ease-in-out]">
          <div className=" bg-gradient-to-r from-transparent via-white/5 to-transparent relative h-full -start-[7rem] w-[5rem] scale-110 rotate-6"></div>
        </div>
      </div>
      { props.children }
    </div>
  )
}

export { Skeleton }
